import { createAsyncThunk, createSlice, PayloadAction, SerializedError } from '@reduxjs/toolkit'
import { Auth } from 'aws-amplify';
import { RootState } from '../../store/store';
import { Loading, Session } from '../../App/app';
import { feedback } from '../../components/Feedback/feedback';
import axios from 'axios';
import { push } from '@lagunovsky/redux-react-router';
import { hgsKeyBackendUri } from '../../uris';

export interface State {
  loading: Loading,
  currentRequestId: string,
  error: SerializedError | null,
  parameters: Parameters,
  session: Session,
}



const initialState: State = {
  loading: 'idle',
  currentRequestId: '',
  error: null,
  parameters: {
    username: '',
    source: '',
    token: '',
  },
  session: {
    accessToken: '',
    idToken: '',
    refreshToken: '',
  }
}

interface Parameters {
  username: string,
  source: string,
  token: string,
}


export const customChallenge = createAsyncThunk(
  'api/customSSO',
  ( _, thunkAPI ) => {
    const state = thunkAPI.getState() as RootState;
    const { currentRequestId, loading } = state.pages.customSSO;

    if ( loading !== 'pending' || thunkAPI.requestId !== currentRequestId ) return ;

    const parameters = state.pages.customSSO.parameters;

    const clientMetaData = {
      loginType: 'sso',
      source: parameters.source,
    }

    return fetch( `${ hgsKeyBackendUri }/initUser`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', },
      body: JSON.stringify( {
        source: parameters.source,
        token: parameters.token,
      })
    } )
      .then( response => {
        if( !response.ok ) {
          throw new Error( 'Failed to initialize user.' );
        } else {
          return response.json();
        }
      } )
      .then( data => data.uuid )

    .then( uuid => {

      return Auth.signIn( uuid ).then( user => {
        return Auth.sendCustomChallengeAnswer(user, parameters.token, clientMetaData).then( () => {
          return Auth.currentSession().then( session => {


              thunkAPI.dispatch( customSessionUpdated({
                accessToken: session.getAccessToken().getJwtToken(),
                idToken: session.getIdToken().getJwtToken(),
                refreshToken: session.getRefreshToken().getToken(),
              })
            )

            return session;
          })
        })
      })

    }).catch( error => {
      const params = new URLSearchParams();
      params.set( 'message', error.message ? error.message : '' );
      thunkAPI.dispatch( feedback( { message: error.message, severity: 'error', } ) );
      thunkAPI.dispatch( push( `/custom-sso/error?${ params }` ) );
      return false;
    })

  }
)


export const customSSOSlice = createSlice({
  name: 'customSSOSlice',
  initialState,
  reducers: {
    customParametersUpdated: (state, action: PayloadAction<Parameters>) => {
      state.parameters = action.payload;
    },
    customSessionUpdated: (state, action: PayloadAction<Session>) => {
      state.session = action.payload;
    },
  },
  extraReducers: ( builder ) => {
      builder.addCase( customChallenge.pending, (state, action) => {
        if (state.loading === 'idle') {
          state.loading = 'pending'
          state.currentRequestId = action.meta.requestId
        }
      })
      .addCase( customChallenge.fulfilled, (state, action) => {
        const { requestId } = action.meta
        if ( state.loading === 'pending' && state.currentRequestId === requestId) {
          state.loading = 'idle'
          // state.entities.push(action.payload)
          state.currentRequestId = ''
        }
      })
      .addCase( customChallenge.rejected, ( state, action, ) => {
        const { requestId } = action.meta
        if (
          state.loading === 'pending' &&
          state.currentRequestId === requestId
        ) {
          state.loading = 'idle'
          state.error = action.error
          state.currentRequestId = ''
        }
      })

  },
})

export const {
  customParametersUpdated,
  customSessionUpdated,
} = customSSOSlice.actions

export default customSSOSlice.reducer
